"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5275],{

/***/ 874232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ EditableText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_TiptapTextEditor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(711293);
/* harmony import */ var _tiptap_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45823);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_ToolbarMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(882522);





function EditableText(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? undefined : _maxLength, _disabled = param.disabled, disabled = _disabled === void 0 ? true : _disabled, _className = param.className, className = _className === void 0 ? "" : _className, _style = param.style, style = _style === void 0 ? {} : _style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_TiptapTextEditor__WEBPACK_IMPORTED_MODULE_2__/* .TiptapTextEditor */ .C, {
        content: content,
        // onTextUpdate={({text}) => onChange('subHeading', text)}
        maxLength: maxLength,
        disabled: disabled,
        className: className,
        style: style,
        renderToolbarProps: function(editor) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tiptap_react__WEBPACK_IMPORTED_MODULE_4__/* .BubbleMenu */ .NM, {
                editor: editor,
                tippyOptions: {
                    duration: 100
                },
                shouldShow: function(props) {
                    return props.editor.isFocused;
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "floating-menu",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_ToolbarMenu__WEBPACK_IMPORTED_MODULE_3__/* .ToolbarMenu */ .H, {
                        editor: editor,
                        showFormattors: false
                    })
                })
            });
        }
    });
}


/***/ })

}]);